import bowser from "bowser";

export const browser = bowser.getParser(navigator.userAgent).getResult();
export const isMobile = (browser.platform.type === "mobile" || browser.platform.type === "tablet") ? true : false;
export const isiOS = (browser.os.name === "iOS") ? true : false;
export const isAndroid = (browser.os.name === "Android")? true : false;
export const isChrome = (browser.browser.name === "Chrome")? true : false;
export const isSafari = (browser.browser.name === "Safari")? true : false;
